module.exports = __webpack_public_path__ + "static/media/13 Tomorrow Is A Long Time.8ddb57de.mp3";